import styles from './LeadSpace.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class LeadSpace extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    get backdrop(): string {
        return this.dataset.backdrop ?? 'backdrop-opacity-black-low';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(`lead-space`, this.backdrop);
        container.innerHTML = `
            <div class="background"></div>
            <div class="body">
                <div class="content">
                    <div class="link">
                        <slot name="link"></slot>
                    </div>
                    <div class="title"></div>
                    <div class="copy"></div>
                    <div class="cta">
                        <slot name="cta"></slot>
                    </div>
                </div>
            </div>
      `;
        // Clone Slots into container to prevent styling issues
        this.cloneSlotContentIntoContainer(container.querySelector('.title'), 'title', false);
        this.cloneSlotContentIntoContainer(container.querySelector('.background'), 'background');
        this.cloneDefaultSlotContentIntoContainer(container.querySelector('.copy'), false);
        this.setHasSlottedToParent(container);
        // Remove CTA if not set
        if(!this.querySelector('[slot=cta]')) {
            container.querySelector('.cta').remove();
        }
        return container;
    }

}

customElements.define('nxt-lead-space', LeadSpace);
